import script from "./EmailInputItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInputItem.vue?vue&type=script&setup=true&lang=js"

import "./EmailInputItem.vue?vue&type=style&index=0&id=e1550222&lang=less"

const __exports__ = script;

export default __exports__